import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ServiceHealth, serviceHealthStatus } from '../../models/devops-mock.data';

@Component({
  selector: 'app-service-health-row',
  imports: [TranslatePipe],
  templateUrl: './service-health-row.component.html',
  styleUrl: './service-health-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceHealthRowComponent {
  readonly service = input.required<ServiceHealth>();

  protected readonly status = computed(() => serviceHealthStatus(this.service().uptime));
}
